import ListItem from '../utils/ListItem';

function TargetsListItem(props) {
  return (
    <ListItem
      to={props.link}
      primary={props.name}
      secondary={props.location}
      meta={props.types}
    />
  );
}

export default TargetsListItem;
